// UI strings for the app's own High Valyrian keys (components/HvKeypad.tsx): the dictation field
// "Kirjoita valyriaksi, mitä kuulit" on a touch phone, where the phone keyboard (Keyman, whose word
// suggestions give the answer away) stays closed. The letter keys read as their letters; only the
// group and the two keys without a letter need a label. Style: docs/FINNISH-STYLE.md.
import { defineArea } from '../area';

export const hvKeypadFi = {
  group: 'Valyrian kirjaimet',
  space: 'Välilyönti',
  backspace: 'Poista',
};

export const hvKeypadEn: typeof hvKeypadFi = {
  group: 'Valyrian letters',
  space: 'Space',
  backspace: 'Delete',
};

// Messages.hvKeypad (i18n/area.ts: collected by area-registry.ts)
export const area = defineArea('hvKeypad', hvKeypadFi, hvKeypadEn);
declare module '../area' {
  interface AreaMessages extends Record<typeof area.key, typeof hvKeypadFi> {}
}
